import React from 'react';
import badImage from "../../../assets/claraViewMedia/Frame-1.png"
import bulb from "../../../assets/claraViewMedia/Frame.png"
import errorIcon from "../../../assets/claraViewMedia/error.png"

const InvalidImage = ({ setCamera, setDemo, onClose }) => {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center font-novatica">
            <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md mx-4">
                <div className="flex justify-end">
                    <button onClick={onClose} className="text-black hover:text-gray-700">
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
                    </button>
                </div>
                <div className="text-center">
                    <img src={errorIcon} alt="Error" className="mx-auto h-32" />
                    <h2 className="text-[17px] font-medium mt-4 text-[#2C2D24]">ERROR</h2>
                </div>
                <p className="text-[15px] text-claraview-tertiary font-medium  mt-2">Improper photo, this may be due to</p>

                <div className="mt-6 space-y-4">
                    <div className="flex items-center">
                        <img src={bulb} alt="Poor lighting" className="h-6 w-6" />
                        <p className="ml-2 text-claraview-tertiary">Poor lighting</p>
                    </div>
                    <div className="flex items-center">
                        <img src={badImage} alt="mismatch" className="h-6 w-6" />
                        <p className="ml-2 text-claraview-tertiary">The image does-not match the reference image</p>
                    </div>
                </div>
                <div className="mt-8 flex flex-col items-center gap-4">
                    <button
                        onClick={setDemo}
                        className="bg-[#2C2D24] h-12 text-white px-4 rounded-lg w-48 text-[17px] font-medium">View Reference</button>
                    <button
                        onClick={setCamera}
                        className="bg-[#C3D8CC] h-12 text-[#2C2D24] px-4 rounded-lg w-48 text-[17px] font-medium">Retake Scan</button>
                </div>
            </div>
        </div>
    );
};

export default InvalidImage;
